import * as React from "react";
import { Route, Routes } from "react-router-dom";

import Loading from "../components/Loading";
import CliLogin from "../pages/CliLogin";
import UiLogin from "../pages/UiLogin";
import AppRouter from "./AppRouter";
import { PrivateRoute } from "./PrivateRoute";

function AuthGate() {
  return (
    <React.Suspense fallback={<Loading />}>
      <Routes>
        <Route path="/cli/login" element={<CliLogin />} />
        <Route path="/ui/login" element={<UiLogin />} />
        <Route
          path="*"
          element={<PrivateRoute component={AppRouter} path="*" />}
        />
      </Routes>
    </React.Suspense>
  );
}

export default AuthGate;
